import React, { useState, useEffect } from "react";
import Avatar from "@mui/material/Avatar";
import { MdOutlineKeyboardArrowDown } from "react-icons/md";
import { useTranslation } from "react-i18next";
import { NavLink } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { CgProfile } from "react-icons/cg";
import { IoLogOutOutline } from "react-icons/io5";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import { userlogout } from "../Redux/Action/AuthAction";
import { Dialog } from "@mui/material";
import { IoClose } from "react-icons/io5";
import { FiLogOut } from "react-icons/fi";

const Navbar = ({ toggleSidebar }) => {
  const { t } = useTranslation("navbar");
  const [dateTime, setDateTime] = useState("");
  const Auth = useSelector((state) => state.Auth);
  const [anchorEl, setAnchorEl] = useState(null);
  const [openMenu, setOpenMenu] = useState(false);
  const [openLogoutModal, setOpenLogoutModal] = useState(false);
  const dispatch = useDispatch();

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
    setOpenMenu(true);
  };

  const handleClose = () => {
    setOpenMenu(false);
  };

  const handleLogoutClick = () => {
    setOpenLogoutModal(true);
    handleClose();
  };

  const handleCloseModal = () => {
    setOpenLogoutModal(false);
  };

  const handleConfirmLogout = () => {
    setOpenLogoutModal(false);
    dispatch(userlogout());
  };

  useEffect(() => {
    const updateDateTime = () => {
      const now = new Date();
      const options = {
        weekday: "long",
        year: "numeric",
        month: "long",
        day: "numeric",
        hour: "numeric",
        minute: "numeric",
        hour12: false,
      };

      const formattedDate = now.toLocaleString(`${localStorage.getItem('i18nextLng') === 'fr' ? "fr-FR" : "en-US"}`, options);
      setDateTime(formattedDate);
    };

    const intervalId = setInterval(updateDateTime, 1000);
    updateDateTime();

    return () => clearInterval(intervalId);
  }, []);

  return (
    <>
      <div className="navbar px-8 py-[18px] flex justify-between items-center fixed top-0 z-50 bg-white w-full">
        <div className="flex justify-start items-center">
          <div className="w-full flex flex gap-2 lg:flex-row lg:gap-4 items-center">
            <button
              onClick={toggleSidebar}
              aria-controls="logo-sidebar"
              type="button"
              className="inline-flex items-center p-2 text-sm text-gray-500 rounded-lg sm:hidden hover:bg-gray-100 focus:outline-none dark:text-gray-400 dark:hover:bg-gray-700 dark:focus:ring-gray-600"
            >
              <span className="sr-only">Open sidebar</span>
              <svg
                className="w-4 h-4"
                aria-hidden="true"
                fill="currentColor"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  clipRule="evenodd"
                  fillRule="evenodd"
                  d="M2 4.75A.75.75 0 012.75 4h14.5a.75.75 0 010 1.5H2.75A.75.75 0 012 4.75zm0 10.5a.75.75 0 01.75-.75h7.5a.75.75 0 010 1.5h-7.5a.75.75 0 01-.75-.75zM2 10a.75.75 0 01.75-.75h14.5a.75.75 0 010 1.5H2.75A.75.75 0 012 10z"
                ></path>
              </svg>
            </button>
            <div className="text-[14px] sm:text-[16px] lg:text-[18px]">
              {t("greeting")},
              <span className="font-700"> {Auth.profile?.name} 👋</span>
            </div>
            <div className="hidden h-[30px] border-[#C7CCD4] border-r-[1px] text-[30px] sm:block"></div>
            <div className="text-[14px] lg:text-[18px] font-500 text-[#535861] text-left hidden sm:block">
              {dateTime}
            </div>
          </div>
        </div>
        <NavLink
          className="flex flex-row items-center gap-3"
          onClick={handleClick}
        >
          <Avatar alt="Cindy Baker" src={Auth.profile?.profile_pic || "/default-profile.png"} />
          <p className="flex items-center gap-3 hidden sm:flex">
            {Auth.profile?.name} <MdOutlineKeyboardArrowDown size={20} />
          </p>
        </NavLink>
        <Menu
          sx={{
            marginTop: "10px",
            "& .MuiMenu-paper": {
              borderRadius: "10px",
            },
          }}
          anchorEl={anchorEl}
          open={openMenu}
          onClose={handleClose}
          anchorOrigin={{
            vertical: "bottom",
            horizontal: "center",
          }}
          transformOrigin={{
            vertical: "top",
            horizontal: "center",
          }}
        >
          <MenuItem onClick={handleClose}>
            <NavLink to={"/profile"} className="w-full flex items-center gap-3">
              <CgProfile size={25} />
              <span className="font-normal">{t('profile')}</span>
            </NavLink>
          </MenuItem>

          <MenuItem onClick={handleLogoutClick} className="gap-3">
            <IoLogOutOutline size={28} />
            <span className="font-normal">{t('logout')}&nbsp;&nbsp;&nbsp;</span>
          </MenuItem>
        </Menu>
      </div>

      {/* Logout Confirmation Modal */}
      <Dialog
        open={openLogoutModal}
        onClose={handleCloseModal}
        PaperProps={{
          sx: {
            borderRadius: "20px",
            width: "300px",
          },
        }}
      >
        <div className="bg-white p-7 flex flex-col gap-5 rounded-[20px]">
          <div className="flex items-start justify-end w-full">
            <span onClick={handleCloseModal}>
              <IoClose size={25} className="cursor-pointer" />
            </span>
          </div>
          <div className="text-center flex flex-col justify-items-center gap-8">
            <span className="bg-white rounded-full text-center mx-auto p-4 border-[2px] border-[#ED3939]">
              <FiLogOut color="#ED3939" size={26} />
            </span>
            <div>
              <div className="text-[20px] font-[600]">{t('logout')}</div>
              {t('logoutConformation')}
            </div>
            <div className="flex gap-5 justify-center">
              <button
                className="bg-[#EDF4FF] text-black rounded-lg h-[40px] w-full max-w-32 my-1 text-[14px] text-center"
                onClick={handleCloseModal}
              >
                {t('cancel')}
              </button>
              <button
                onClick={handleConfirmLogout}
                className="bg-[#ED3939] text-white rounded-lg h-[40px] w-full max-w-32 my-1 text-[14px] text-center"
                Delete
              >
                {t('logout')}
              </button>
            </div>
          </div>
        </div>
      </Dialog>
    </>
  );
};

export default Navbar;
